import {useContext} from 'react'

import Context from '@s-ui/react-context'

import {getFiltersListFromCustomConfig} from './utils.js'

const DEFAULT_CATEGORY_ID = 0
const DEFAULT_OFFER_TYPE_ID = 0

const useSearchFilters = ({
  categoryId,
  customFiltersConfig = [],
  filteredOfferTypeId,
  listingSectionId,
  offerTypeId: paramOfferTypeId,
  pageName = ''
}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  if (customFiltersConfig.length) return getFiltersListFromCustomConfig({config: customFiltersConfig})

  const {
    ADS_FILTERS_MAP,
    ADS_SEARCH_LITE_FILTERS_MAP,
    ALL_OFFER_TYPES_ADS_FILTERS_MAP,
    DEFAULT_FILTERS_MAP,
    MODELS_LIST_FILTERS_CONF,
    OFFER_TYPE_NEW,
    OFFER_TYPE_SUBSCRIPTION,
    SUBSCRIPTION_FILTERS_CONF,
    TECHNICAL_DETAILS_SEARCH_FILTERS_MAP
  } = config.get('search')

  const {NOT_AVAILABLE_FILTERS} = config.get('alerts')

  const {LISTING_SECTION_IDS} = config.get('COMMON')

  const {
    ADS_LIST_PAGE_NAME: adsListPageName,
    ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME: adsListBusinessSubscriptionPageName = '',
    ADS_LIST_SUBSCRIPTION_PAGE_NAME: adsListSubscriptionPageName = '',
    HOME_PAGE_NAME: homePageName,
    MAKES_DISTRIBUTOR_PAGE_NAME: makesDistributorPageName = '',
    TECHNICAL_DETAILS_SEARCH_PAGE_NAME: technicalDetailsSearchPageName,
    TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME: technicalDetailsSearchResultsPageName,
    USER_SAVED_SEARCHES_PAGE_NAME: alertsPageName
  } = config.get('page')

  const getAdsListFilters = () => {
    const offerTypeId = filteredOfferTypeId === OFFER_TYPE_NEW ? filteredOfferTypeId : paramOfferTypeId
    const FILTERS_CATEGORY_ID = categoryId || DEFAULT_CATEGORY_ID
    const FILTERS_OFFER_TYPE_ID = offerTypeId || DEFAULT_OFFER_TYPE_ID

    return listingSectionId === LISTING_SECTION_IDS.ALL_VEHICLES
      ? ALL_OFFER_TYPES_ADS_FILTERS_MAP
      : ADS_FILTERS_MAP[FILTERS_CATEGORY_ID][FILTERS_OFFER_TYPE_ID] || DEFAULT_FILTERS_MAP
  }

  const getAlertsListFilters = () => {
    const isSubscriptionAlert = paramOfferTypeId === OFFER_TYPE_SUBSCRIPTION
    const filters = isSubscriptionAlert ? SUBSCRIPTION_FILTERS_CONF : getAdsListFilters()
    return filters.filter(filter => !NOT_AVAILABLE_FILTERS.includes(filter))
  }

  const getFilters = ({pageName}) => {
    switch (pageName) {
      case adsListPageName:
        return getAdsListFilters()
      case adsListBusinessSubscriptionPageName:
      case adsListSubscriptionPageName:
        return SUBSCRIPTION_FILTERS_CONF
      case makesDistributorPageName:
        return MODELS_LIST_FILTERS_CONF
      case technicalDetailsSearchPageName:
      case technicalDetailsSearchResultsPageName:
        return TECHNICAL_DETAILS_SEARCH_FILTERS_MAP
      case homePageName:
        return ADS_SEARCH_LITE_FILTERS_MAP
      case alertsPageName:
        return getAlertsListFilters()
      default:
        return getAdsListFilters()
    }
  }

  return getFilters({pageName})
}

export {useSearchFilters}
